import React from "react";

const Benefits = ({benefits}) => {
  return (
    <div className="row g-4">
      {benefits.map((benefit, index) => (
        <div className="col-md-6" key={index}>
          <div className="bg-white p-4 rounded shadow-sm hover-shadow border transition">
            <div className="d-flex align-items-center mb-3">
              <div
                className="d-flex align-items-center justify-content-center rounded-circle me-3"
                style={{
                  width: "64px",
                  height: "64px",
                  backgroundColor: "#f9f5e8",
                  color: "#c69933",
                }}
              >
                <i className={`fas ${benefit.icon} fa-2x`}></i>
              </div>
              <h5 className="fw-bold mb-1">{benefit.title}</h5>
            </div>
            <p className="text-muted mb-0">{benefit.description || benefit.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Benefits;
